// extracted by mini-css-extract-plugin
module.exports = {"page-comp":"E_page-comp__DiTR2"};